import { Injector } from '@angular/core';
import { ItemModel } from '../../../../models/itemModel';
import { FrameItem } from '../../../../models/session';
import { IframeComponent } from '../../iframe/iframe.component';
import { BoardIframeConfigurations } from './board-iframe-configurations';
import { BoardApp } from './board-web-viewer';
import { CreationContext } from './board-item-configurations';

export class BoardIframe extends BoardApp<BoardIframeConfigurations> {
  AngularComponentClass = IframeComponent;

  constructor(
    injector: Injector,
    configurations: BoardIframeConfigurations,
    creationContext: CreationContext,
  ) {
    super(injector, ItemModel.IFrame, configurations, creationContext);
  }

  public toFrameItem(): FrameItem {
    return {
      ...super.toFrameItem(),
      model: ItemModel.IFrame,
      iframe_state: {
        url: this.configurations.url,
        sharedUrl: this.configurations.sharedUrl,
        title: this.configurations.title,
        type: this.configurations.appInstanceId,
      },
      isPrivate: this.configurations.isPrivate,
      interactionsLocked: this.configurations.interactionsLocked,
    };
  }
}
